import api from "../api/configAxios";
import Controller from "../common/controller";

export const checkSms = async (endpoint, email, token) => {
  try {
    var response = await api.get(
      `${Controller.dynamoDB}/${endpoint}?email=${email}&otp=${token}`
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error);
  }
};
